import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import { FaCashRegister, FaRegTrashAlt, FaRegEdit } from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { api } from "../../../../api/api";

function SubCategory() {
  const [name, setName] = useState("");
  const [pointList, setPointList] = useState([]);
  const [point, setPoint] = useState("");
  const [type, setType] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const [updateDataList, setUpdateDataList] = useState([]);
  const [upCode, setUpCode] = useState("");
  const [upName, setUpName] = useState("");
  const [upDesc, setUpDesc] = useState("");
  const [relatedCat, setRelatedCat] = useState("");
  const [relatedCatID, setRelatedCatID] = useState("");
  const [Id, setId] = useState("");
  const navigate = useNavigate();

  // const [categoryLists, setCategoryLists] = useState([]);

  const handleDelete = (event) => {
    api
      .delete("gift-point/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });
        const result = pointList.filter((item) => item._id !== event);
        setPointList(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          showCancelButton: false,
          timer: 3000,
        });
      });
  };

  const handleUpdate = (event) => {
    // console.log(event, 'event')
    const getCatUpdate = async () => {
      try {
        const res = await api.get("v1/gift-point/" + event);
        console.log(res.data.data, "event");
        setPoint(res.data.data.point);
        setName(res.data.data.name);

        setDescription(res.data.data.description);
      } catch (err) {}
    };
    getCatUpdate();
    setShowUpdate(true);
    setId(event);
  };

  const Update = () => {
    const data = {
      name: name,
      point: point,
      description: description,
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("v1/gift-point/" + Id, data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Updated Data!",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });

        //  setSubCategoryLists([...subCategoryLists, response.data.data]);
        setPointList(
          pointList.map((category) => {
            if (category._id === response.data.data._id) {
              return response.data.data;
            } else {
              return category;
            }
          })
        );
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  const Create = () => {
    const data = {
      name: name,
      point: point,

      description: description,
    };

    // alert(JSON.stringify(data));

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .post("v1/gift-point", data, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Data!",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });

        setPointList([...pointList, response.data.data]);
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          showCancelButton: false,
          timer: 3000,
        });
      });
  };
  useEffect(() => {
    const getSubCategory = async () => {
      try {
        const res = await api.get("v1/gift-points");

        // console.log(res.data, "sub cat");
        setPointList(res.data.data);
      } catch (err) {}
    };

    getSubCategory();
  }, []);
  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active fs-5">Gift Point List</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Main content --> */}

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-9">
              <div className="card">
                <div className="card-header">
                  {/* <h3 className="card-title">Cost Center List</h3> */}
                </div>
                <div className="card-body">
                  <table id="example1" className="table">
                    <thead className=" bg-info">
                      <tr>
                        <th>No</th>
                        <th>Name</th>

                        <th>Point</th>

                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    {pointList.map((cat, i) => (
                      <tbody className="">
                        <tr>
                          <td>{++i}</td>
                          <td>{cat.name}</td>

                          <td>{cat.point}</td>

                          <td>{cat.description}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={(e) => handleUpdate(cat._id)}
                            >
                              <FaRegEdit />
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={(e) => handleDelete(cat._id)}
                            >
                              <FaRegTrashAlt />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </div>
            </div>

            {showUpdate ? (
              <div className="col-md-3">
                <div className="card">
                  <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                    Update Tier Level
                  </h5>
                  <div className="px-3 py-3">
                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Name
                      </label>
                      <input
                        type="text"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        value={name}
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Point
                      </label>
                      <input
                        type="number"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        value={point}
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setPoint(e.target.value)}
                      />
                    </div>

                    <div class="form-group">
                      <label for="name" className="text-secondary">
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        id="desc"
                        value={description}
                        //   ref={(el) => (this.description = el)}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>
                    <button
                      style={{ backgroundColor: "#0b9490", color: "white" }}
                      className="btn  form-control text-center fw-5"
                      onClick={Update}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-md-3">
                <div className="card">
                  <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                    Create Tier Level
                  </h5>
                  <div className="px-3 py-3">
                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Name
                      </label>
                      <input
                        type="text"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div class="form-group">
                      <label for="code" className="text-secondary">
                        Point
                      </label>
                      <input
                        type="number"
                        class="form-control border-info"
                        name="code"
                        id="code"
                        //   ref={(el) => (this.name = el)}
                        onChange={(e) => setPoint(e.target.value)}
                      />
                    </div>

                    <div class="form-group">
                      <label for="name" className="text-secondary">
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        id="desc"
                        //   ref={(el) => (this.description = el)}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>
                    <button
                      style={{ backgroundColor: "#0b9490", color: "white" }}
                      className="btn  form-control text-center fw-5"
                      onClick={Create}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/*<!-- /.container-fluid --> */}
      </section>
    </>
  );
}
export default SubCategory;
